//  import React, { useState } from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "../Sidebar";

// const AppLayout: React.FC = () => {
//   const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);

//   return (
//     <div className="flex min-h-screen">
//       <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

//       {/* <main className="flex-1 bg-gray-50 transition-all duration-300">
//         <Outlet />
//       </main> */}
//       <main className="flex-1 bg-gray-50 transition-all duration-300 px-6 py-4">
//   <Outlet />
// </main>

//     </div>
//   );
// };

//  export default AppLayout;

import React, { Suspense, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import ComponetLoader from "../shared/ComponetLoader";

const AppLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);
  const location = useLocation();
  return (
    <div className="flex min-h-screen">
      {/* <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} /> */}
      <div className="fixed left-0 top-0 h-full z-40">
        <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      </div>

      {/* Main content dynamically shifts */}
      <main
        className={`
          flex-1 bg-gray-50 transition-all duration-300 px-6 py-4
          ${sidebarOpen ? "ml-72" : "ml-20"}    
        `}
      >
        <Suspense fallback={<ComponetLoader />}>
          {/* 👇 KEY forces remount on every route change */}
          <Outlet key={location.pathname} />
        </Suspense>
        
      </main>
    </div>
  );
};

export default AppLayout;
